/* Svensk katalog for locale-payroll-payments-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'err.pensionCorrection.inactive': 'Ingen aktiv OTP-betalning att korrigera.',
  'err.pensionCorrection.legacy': 'Den här historiska OTP-betalningen måste korrigeras efter en redovisningsmässig genomgång.',
  'err.pensionCorrection.stale': 'OTP-betalningen har ändrats. Ladda om sidan innan du korrigerar.',
  'err.pensionCorrection.reason': 'Ange orsaken till korrigeringen.',
  'err.pensionCorrection.reported': 'A-meldingen måste gås igenom innan OTP i inrapporterad lön kan korrigeras.',
  'err.pensionCorrection.settled': 'Makulera periodbetalningen av arbetsgivaravgift innan OTP korrigeras.',
  'err.pensionCorrection.missing': 'Hittar inte bokföringen av OTP-betalningen.',
  'pay.viewPensionPosting': 'Visa kontering',
  'pay.pensionDetails': 'Visa betalning',
  'pay.correctPensionPayment': 'Korrigera OTP-betalning',
  'pay.annulPensionPayment': 'Makulera OTP-betalning',
  'pay.pensionCorrectionSaved': 'OTP-betalningen har korrigerats.',
  'pay.correctionReason': 'Orsak till korrigering',
  'pay.pensionCorrectionExplanation': 'Den ursprungliga OTP-betalningen motbokas i den ursprungliga, öppna perioden. Vid korrigering registreras en ny betalning. Lönekörningen och löneutbetalningen behålls. Detta ändrar bokföringen, inte en genomförd banköverföring.',
  'trv.approveExpense': 'Godkänn utlägg',
  'pay.taxOnNonCashBenefits': 'Skatteavdrag på förmåner',
  'pay.netReconciliation': 'Avvikelse mellan lönerader och sparad nettolön',
  'pay.netAdjustmentExplanation': 'Dras från kontant utbetalning; skatten ingår ovan.',
  'pay.viewPayslip': 'Visa lönebesked',
  'pay.resendPayslip': 'Skicka igen',
  'pay.missingPensionBankAccountReminder': 'Du har inte lagt till något bankkonto. Kom ihåg att lägga till kontot som pensionen har betalats från. Du kan ändå registrera betalningen.',
  'pay.missingBankAccountReminder': 'Du har inte lagt till något bankkonto. Kom ihåg att lägga till kontot som lönen har betalats från. Du kan ändå registrera utbetalningen.',
});
